import { createContext, useContext } from 'react';
import { enableStaticRendering } from 'mobx-react-lite';
import RegionsStore from '@features/footer/components/LanguageSelect/mobX/stores/RegionsStore';
enableStaticRendering(typeof window === 'undefined');
let store;
const initializeStore = () => {
  const newStore = store ?? new RegionsStore();
  if (typeof window === 'undefined') return newStore;
  if (!store) store = newStore;
  return newStore;
};
const RegionsStoreContext = createContext<RegionsStore>(initializeStore());
const useRegionsStore = () => useContext(RegionsStoreContext);
export { RegionsStore, useRegionsStore };